import React, { useState, useEffect, useRef } from 'react';
import { BiErrorCircle } from 'react-icons/bi';
import { BsArrowUpCircleFill, BsArrowRightCircleFill } from 'react-icons/bs';
import { FiCornerDownRight } from 'react-icons/fi';

const TextArea = ({
  id = undefined,
  name,
  label,
  placeholder = 'What can I answer for you?',
  value,
  handleChange,
  handleKeyDown,
  error,
  disabled = false,
  grouptext,
  icon_left = <FiCornerDownRight />,
  icon_left_show = true,
  icon_left_click,
  icon_left_class = 'cornerdown',
  icon = <BsArrowRightCircleFill />,
  icon_toggle = <BsArrowUpCircleFill />,
  show_icon_toggle = false,
  iconclick,
  iconposition = 'right',
  iconclass = 'send',
  customclass = 'mt-2 mb-2'
}) => {
  const textareaRef = useRef(null);
  const [currentIcon, setCurrentIcon] = useState(icon);
  const [rowCount, setRowCount] = useState(1);

  const adjustTextareaHeight = () => {
    const textarea = textareaRef.current;
    textarea.style.height = 'auto';
    const scrollHeight = textarea.scrollHeight;
    const lineHeight = parseInt(window.getComputedStyle(textarea).lineHeight, 10);
    const maxHeight = 4 * lineHeight;
    textarea.style.height = `${Math.min(scrollHeight, maxHeight)}px`;
    const newRowCount = Math.ceil(scrollHeight / lineHeight);
    setRowCount(newRowCount);
  };

  useEffect(() => {
    adjustTextareaHeight();
  }, [value]);

  useEffect(() => {
    if (rowCount > 2 && show_icon_toggle) {
      setCurrentIcon(icon_toggle);
    } else {
      setCurrentIcon(icon);
    }
  }, [rowCount, icon, icon_toggle, show_icon_toggle]);

  return (
    <div className={`${customclass}`}>
      {label && (
        <label htmlFor={name} style={{ color: '#0678e6', fontWeight: 600 }}>
          {label}
        </label>
      )}
      <div className={`input-group ${rowCount > 2 ? 'icons-bottom' : ''}`}>
        {icon_left_show && (
          <div className={`form-icon ${icon_left_class}`} onClick={icon_left_click}>
            {icon_left}
          </div>
        )}
        {currentIcon && iconposition === 'left' && (
          <div className={`form-icon ${iconclass}`} onClick={iconclick}>
            {currentIcon}
          </div>
        )}
        <textarea
          id={id ? id : name}
          name={name}
          value={value}
          onChange={(e) => {
            handleChange(e);
            adjustTextareaHeight();
          }}
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
          className='form-control'
          disabled={disabled}
          autoComplete='off'
          aria-label={placeholder}
          aria-describedby='basic-addon2'
          rows={1}
          ref={textareaRef}
          style={{ resize: 'none', overflow: 'auto' }}
        ></textarea>
        {currentIcon && iconposition !== 'left' && (
          <div
            className={`form-icon ${iconclass} ${value.length > 0 ? 'active' : 'disable'}`}
            onClick={iconclick}
          >
            {currentIcon}
          </div>
        )}
        {grouptext && (
          <span className='input-group-text' id='basic-addon2'>
            {grouptext}
          </span>
        )}
      </div>
      {error && (
        <div className='alert-message'>
          <BiErrorCircle /> {` ${error}`}
        </div>
      )}
    </div>
  );
};

export default TextArea;
